F
<template>
    <AppLayout
        page="/dashboard"
        pageTitle="Weekly Recap"
        backLink="/dashboard/reports"
    >
        <v-overlay :value="retryLoading" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-col cols="12" class="pa-1">
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="soli-subtitle"
                                    >{{
                                        `${globalMomentDate(
                                            rangeStart
                                        )} to ${globalMomentDate(rangeEnd)}`
                                    }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item></v-list
                    >
                    <v-data-table
                        :headers="headers"
                        :items="weeklyLocationReport"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        @click:row="[(showDetails = true), (details = $event)]"
                        style="cursor: pointer"
                    >
                        <template v-slot:[`item.net`]="{ item }">
                            {{
                                item.enrollments.length -
                                item.withdrawals.length
                            }}
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>

        <v-dialog
            v-model="showDetails"
            :fullscreen="$vuetify.breakpoint.xs ? true : false"
            :content-class="$vuetify.breakpoint.xs ? '' : 'soli-round'"
            :transition="
                $vuetify.breakpoint.smAndDown
                    ? 'dialog-bottom-transition'
                    : 'dialog-transition'
            "
            max-width="600px"
            @click:outside="showDetails = null"
        >
            <v-card v-if="details">
                <v-btn
                    icon
                    @click="showDetails = null"
                    class="ma-3 soli-close soli-grey soli-text-shadow"
                    ><v-icon>clear</v-icon></v-btn
                >
                <v-card-title>{{ `${details.location} Details` }}</v-card-title>
                <v-container class="pt-0 px-5">
                    <v-list
                        dense
                        subheader
                        v-for="item in getDetails"
                        :key="item.title"
                    >
                        <v-subheader>{{ item.title }}</v-subheader>
                        <v-list-item
                            dense
                            v-for="(name, idx) in item.value"
                            :key="idx"
                            >{{ name }}</v-list-item
                        >
                    </v-list>
                </v-container></v-card
            ></v-dialog
        >

        <SoliSnack
            v-if="showMessage"
            @hide="showMessage = false"
            :text="$page.props.successMessage"
        ></SoliSnack>
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import globalMoment from "../../Mixins/GlobalMoment";

export default {
    props: ["weeklyLocationReport", "rangeStart", "rangeEnd"],
    mixins: [globalMoment],
    components: {
        AppLayout,
        Link,
    },
    data() {
        return {
            showMessage: false,
            retryLoading: false,
            details: null,
            showDetails: false,
            headers: [
                {
                    text: "Location",
                    align: "start",
                    sortable: true,
                    value: "location",
                },
                {
                    text: "Assessments",
                    align: "start",
                    sortable: true,
                    value: "assessments.length",
                },
                {
                    text: "Enrollments",
                    align: "start",
                    sortable: true,
                    value: "enrollments.length",
                },
                {
                    text: "Withdrawals",
                    align: "start",
                    sortable: true,
                    value: "withdrawals.length",
                },
                {
                    text: "Lost Assessments",
                    align: "start",
                    sortable: true,
                    value: "lostAssessments.length",
                },
                {
                    text: "Net",
                    align: "start",
                    sortable: false,
                    value: "net",
                },
            ],
        };
    },
    methods: {},
    computed: {
        getDetails() {
            if (!this.details) return;
            return [
                {
                    title: "Assessments",
                    value: this.details.assessments,
                },
                {
                    title: "Enrollments",
                    value: this.details.enrollments,
                },
                {
                    title: "Withdrawals",
                    value: this.details.withdrawals,
                },
                {
                    title: "Lost Assessments",
                    value: this.details.lostAssessments,
                },
            ];
        },
    },
};
</script>
